import { Routes } from '@angular/router';
import {
  createClientRoutes,
  PostInviteComponent,
  SubscriptionInProgressComponent,
} from '@dss-libs/portal/feature/portal-core-features';
import { AuthGuard, ClientGuard, ProfileReadyGuard, RolesGuard } from '@dss-libs/shared/guard/common-guards';
import { LoginComponent } from '@dss-libs/shared/feature/auth';
import { PortalCoreComponent } from './pages/portal-core/portal-core.component';
import { CreateClientComponent } from './pages/create-client/create-client.component';
import { portalCoreRoutes } from './pages/portal-core/portal-core.routes';

export const appRoutes: Routes = [
  {
    path: '',
    canActivate: [ClientGuard, AuthGuard, ProfileReadyGuard],
    canActivateChild: [RolesGuard],
    loadComponent: () => PortalCoreComponent,
    children: portalCoreRoutes,
  },
  {
    path: 'login',
    loadComponent: () => LoginComponent,
  },
  {
    path: 'createClient',
    canActivate: [AuthGuard],
    loadComponent: () => CreateClientComponent,
    title: 'Create client',
    children: createClientRoutes,
  },
  {
    path: 'subscription-in-progress',
    loadComponent: () => SubscriptionInProgressComponent,
  },
  {
    path: 'postInvite',
    component: PostInviteComponent,
  },

  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
